export default __webpack_public_path__ + "static/3-3-0-0-f161046ad93a9d072ac8af2b2f44764c.jpg";